import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-schedule-view-delete-dialog',
    template: require('./schedule-one-time-view-dialog-delete.html')
})
export class ScheduleOneTimeViewDeleteDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<ScheduleOneTimeViewDeleteDialog>) public dialogRef: MatDialogRef<ScheduleOneTimeViewDeleteDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}